const RESEND_COOLDOWN_STORAGE_PREFIX = 'zenbox:confirmation-code-resend:'
export const RESEND_COOLDOWN_BASE_SECONDS = 60
const RESEND_COOLDOWN_RESET_SECONDS = 30 * 60
const RESEND_COOLDOWN_MAX_SECONDS = 15 * 60

type ResendCooldownStorage = {
    lastRequestAt: number
    requestCount: number
}

const getStorageKey = (cellphone: string) => `${RESEND_COOLDOWN_STORAGE_PREFIX}${encodeURIComponent(cellphone)}`

const getStoredData = (cellphone: string): ResendCooldownStorage | null => {
    try {
        const value = localStorage.getItem(getStorageKey(cellphone))
        if (!value) return null

        const data = JSON.parse(value) as ResendCooldownStorage
        if (!Number.isFinite(data.lastRequestAt) || !Number.isInteger(data.requestCount) || data.requestCount < 1) return null
        return data
    } catch {
        return null
    }
}

const getCooldownDuration = (requestCount: number) => Math.min(
    RESEND_COOLDOWN_BASE_SECONDS * (2 ** (requestCount - 1)),
    RESEND_COOLDOWN_MAX_SECONDS,
)

export const getResendCooldown = (cellphone: string) => {
    const data = getStoredData(cellphone)
    if (!data) return 0

    const elapsedSeconds = Math.floor((Date.now() - data.lastRequestAt) / 1000)
    if (elapsedSeconds < 0 || elapsedSeconds >= RESEND_COOLDOWN_RESET_SECONDS) return 0

    return Math.max(getCooldownDuration(data.requestCount) - elapsedSeconds, 0)
}

export const saveResendRequest = (cellphone: string) => {
    const previousData = getStoredData(cellphone)
    const elapsedSeconds = previousData ? Math.floor((Date.now() - previousData.lastRequestAt) / 1000) : RESEND_COOLDOWN_RESET_SECONDS
    const requestCount = previousData && elapsedSeconds >= 0 && elapsedSeconds < RESEND_COOLDOWN_RESET_SECONDS
        ? previousData.requestCount + 1
        : 1
    const data: ResendCooldownStorage = { lastRequestAt: Date.now(), requestCount }

    try {
        localStorage.setItem(getStorageKey(cellphone), JSON.stringify(data))
    } catch {
        // O cooldown em memória continua funcionando mesmo se o storage estiver indisponível.
    }

    return getCooldownDuration(requestCount)
}

export const clearResendRequest = (cellphone: string) => {
    try {
        localStorage.removeItem(getStorageKey(cellphone))
    } catch {
        // Não interrompe o login caso o storage esteja indisponível.
    }
}
